import React,{useEffect} from 'react'
import { useToasts } from 'react-toast-notifications'
import { connect } from 'react-redux'
const Toast = props => {
  const { addToast } = useToasts()
  useEffect(() => {
    if (props.toasts.length > 0) {
      props?.toasts?.map(toast => {
        return addToast(toast.msg, {
          appearance: toast.type,
          autoDismiss: true
        })
      })
    }
  }, [props.toasts])

  return <div>{/*  */}</div>
}

const mapStatetoprops = state => ({
  toasts: state.toasts
})

export default connect(mapStatetoprops)(Toast)
